import { useEffect, useLayoutEffect } from 'react';
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// Helps with SSR & eslint-plugin-react-hooks
// Ensure the name used in components is useLayoutEffect
export default useIsomorphicLayoutEffect;
